export const BlackCoins = ({ size = 30 }) => (
  
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    style={{marginBottom: '-5px'}}
  >
    <g filter="url(#filter0_n_19334_708)">
      <rect
        x="11.2104"
        y="2.62451"
        width="11.8378"
        height="11.8378"
        rx="5.91892"
        transform="rotate(46.5027 11.2104 2.62451)"
        fill="black"
      />
      <rect
        x="11.2012"
        y="2.97794"
        width="11.3378"
        height="11.3378"
        rx="5.66892"
        transform="rotate(46.5027 11.2012 2.97794)"
        stroke="white"
        stroke-width="0.5"
      />
    </g>
    <g filter="url(#filter1_n_19334_708)">
      <rect
        x="11.1796"
        y="3.82007"
        width="10.1467"
        height="10.1467"
        rx="5.07336"
        transform="rotate(46.5027 11.1796 3.82007)"
        fill="black"
      />
      <rect
        x="11.161"
        y="4.52693"
        width="9.14672"
        height="9.14672"
        rx="4.57336"
        transform="rotate(46.5027 11.161 4.52693)"
        stroke="#7515ED"
      />
    </g>
    <g filter="url(#filter2_d_19334_708)">
      <path
        d="M12.8264 10.4955C12.7137 10.6968 12.5788 10.8749 12.4235 11.023C12.2593 11.1795 12.0773 11.308 11.8727 11.4085C11.671 11.5071 11.4825 11.562 11.3094 11.5691C11.2939 11.7418 11.2303 11.9273 11.1218 12.1247C11.0116 12.3244 10.8746 12.5002 10.7104 12.6567C10.5555 12.8044 10.3713 12.9314 10.1646 13.034C9.95586 13.1386 9.76555 13.1959 9.5963 13.2028L9.57666 13.2632L10.1422 13.8576C10.32 13.8504 10.5121 13.7941 10.719 13.6935C10.9281 13.59 11.1146 13.4587 11.2825 13.2985C11.4412 13.1472 11.5795 12.9652 11.6946 12.7588C11.8122 12.5499 11.8798 12.3585 11.8952 12.1857C12.073 12.1785 12.2651 12.1222 12.472 12.0216C12.6815 11.9178 12.868 11.7864 13.036 11.6263C13.1947 11.4749 13.333 11.2929 13.4481 11.0865C13.5657 10.8777 13.6332 10.6862 13.6487 10.5135L13.0831 9.91903L13.022 9.93574C13.0069 10.1047 12.9409 10.2918 12.8264 10.4955Z"
        fill="white"
      />
      <path
        d="M11.9474 9.57212C11.8351 9.77382 11.6998 9.95148 11.5445 10.0996C11.3804 10.2561 11.1983 10.3846 10.9938 10.4852C10.7921 10.5837 10.6035 10.6386 10.4304 10.6457C10.4149 10.8185 10.3514 11.004 10.2429 11.2013C10.1326 11.401 9.99563 11.5768 9.83148 11.7333C9.67659 11.8811 9.49237 12.0081 9.28569 12.1106C9.0769 12.2152 8.88659 12.2725 8.71734 12.2794L8.6977 12.3398L9.2636 12.9346C9.44135 12.9274 9.63349 12.8711 9.84039 12.7705C10.0498 12.6674 10.236 12.5357 10.4039 12.3755C10.5626 12.2242 10.7009 12.0422 10.816 11.8358C10.9336 11.6269 11.0012 11.4355 11.0166 11.2627C11.1944 11.2555 11.3865 11.1992 11.5934 11.0986C11.8028 10.9955 11.989 10.8638 12.157 10.7037C12.3156 10.5523 12.454 10.3703 12.569 10.1639C12.6867 9.95506 12.7542 9.76363 12.7697 9.59086L12.2041 8.99642L12.143 9.01313C12.1283 9.18165 12.0623 9.36878 11.9474 9.57212Z"
        fill="white"
      />
      <path
        d="M7.98514 11.5085L7.96549 11.5689L8.53104 12.1633L12.0371 8.81958L11.4716 8.22514L11.4104 8.24185L7.98514 11.5085Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter3_n_19334_708)">
      <rect
        x="-0.000366211"
        width="11.8378"
        height="11.8378"
        rx="5.91892"
        fill="black"
      />
      <rect
        x="0.249634"
        y="0.25"
        width="11.3378"
        height="11.3378"
        rx="5.66892"
        stroke="white"
        stroke-width="0.5"
      />
    </g>
    <g filter="url(#filter4_n_19334_708)">
      <rect
        x="0.843628"
        y="0.845459"
        width="10.1467"
        height="10.1467"
        rx="5.07336"
        fill="black"
      />
      <rect
        x="1.34363"
        y="1.34546"
        width="9.14672"
        height="9.14672"
        rx="4.57336"
        stroke="#7515ED"
      />
    </g>
    <g filter="url(#filter5_d_19334_708)">
      <path
        d="M6.98434 4.40984C7.0528 4.63018 7.0891 4.85057 7.08965 5.06518C7.09022 5.29202 7.0581 5.51249 6.99024 5.73011C6.92287 5.94424 6.83294 6.11884 6.7189 6.24928C6.8336 6.37941 6.92441 6.55319 6.99286 6.76772C7.06183 6.98515 7.09507 7.20554 7.09564 7.43238C7.09618 7.64641 7.06151 7.86748 6.99366 8.088C6.9258 8.31143 6.83639 8.48895 6.7249 8.61647L6.75517 8.67226L7.57566 8.67118C7.69275 8.53725 7.7842 8.35915 7.85359 8.13979C7.92247 7.91693 7.95559 7.69122 7.95501 7.45916C7.95445 7.23988 7.91763 7.01426 7.84711 6.78869C7.77658 6.55962 7.68422 6.37886 7.56952 6.24873C7.68661 6.1148 7.77806 5.9367 7.84746 5.71734C7.91633 5.49391 7.94946 5.26819 7.94887 5.03613C7.94831 4.81686 7.91149 4.59124 7.84097 4.36566C7.77044 4.13659 7.67808 3.95583 7.56338 3.8257L6.74289 3.82679L6.71291 3.88266C6.82505 4.00989 6.91536 4.18659 6.98434 4.40984Z"
        fill="white"
      />
      <path
        d="M5.70831 4.41219C5.77729 4.63253 5.81308 4.85292 5.81362 5.06753C5.8142 5.29437 5.78208 5.51484 5.71421 5.73246C5.64685 5.94658 5.55692 6.12119 5.44288 6.25162C5.55758 6.38176 5.64839 6.55554 5.71684 6.77007C5.78581 6.9875 5.81904 7.20789 5.81962 7.43473C5.82016 7.64876 5.78549 7.86982 5.71763 8.09035C5.64978 8.31378 5.56037 8.49129 5.44888 8.61882L5.47914 8.67461L6.30014 8.67352C6.41723 8.5396 6.50869 8.3615 6.57808 8.14213C6.64746 7.91928 6.68008 7.69357 6.67949 7.4615C6.67894 7.24223 6.64211 7.01661 6.57159 6.79104C6.50106 6.56197 6.4087 6.38121 6.29401 6.25108C6.4111 6.11715 6.50255 5.93905 6.57194 5.71969C6.64133 5.49684 6.67394 5.27112 6.67336 5.03906C6.6728 4.81979 6.63598 4.59417 6.56546 4.36859C6.49493 4.13953 6.40257 3.95876 6.28787 3.82863L5.46738 3.82972L5.4374 3.8856C5.54953 4.01224 5.63984 4.18893 5.70831 4.41219Z"
        fill="white"
      />
      <path
        d="M4.38497 8.61904L4.41523 8.67484L5.23572 8.67375L5.22345 3.82886L4.40296 3.82995L4.37298 3.88582L4.38497 8.61904Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_n_19334_708"
        x="5.07202"
        y="5.07324"
        width="11.8378"
        height="11.8379"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feTurbulence
          type="fractalNoise"
          baseFrequency="0.25 0.25"
          stitchTiles="stitch"
          numOctaves="3"
          result="noise"
          seed="7375"
        />
        <feColorMatrix in="noise" type="luminanceToAlpha" result="alphaNoise" />
        <feComponentTransfer in="alphaNoise" result="coloredNoise1">
          <feFuncA
            type="discrete"
            tableValues="1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
          />
        </feComponentTransfer>
        <feComposite
          operator="in"
          in2="shape"
          in="coloredNoise1"
          result="noise1Clipped"
        />
        <feFlood flood-color="rgba(0, 0, 0, 0.25)" result="color1Flood" />
        <feComposite
          operator="in"
          in2="noise1Clipped"
          in="color1Flood"
          result="color1"
        />
        <feMerge result="effect1_noise_19334_708">
          <feMergeNode in="shape" />
          <feMergeNode in="color1" />
        </feMerge>
      </filter>
      <filter
        id="filter1_n_19334_708"
        x="5.91803"
        y="5.91895"
        width="10.1468"
        height="10.1467"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feTurbulence
          type="fractalNoise"
          baseFrequency="0.25 0.25"
          stitchTiles="stitch"
          numOctaves="3"
          result="noise"
          seed="7963"
        />
        <feColorMatrix in="noise" type="luminanceToAlpha" result="alphaNoise" />
        <feComponentTransfer in="alphaNoise" result="coloredNoise1">
          <feFuncA
            type="discrete"
            tableValues="1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
          />
        </feComponentTransfer>
        <feComposite
          operator="in"
          in2="shape"
          in="coloredNoise1"
          result="noise1Clipped"
        />
        <feFlood flood-color="rgba(0, 0, 0, 0.25)" result="color1Flood" />
        <feComposite
          operator="in"
          in2="noise1Clipped"
          in="color1Flood"
          result="color1"
        />
        <feMerge result="effect1_noise_19334_708">
          <feMergeNode in="shape" />
          <feMergeNode in="color1" />
        </feMerge>
      </filter>
      <filter
        id="filter2_d_19334_708"
        x="3.96552"
        y="8.2251"
        width="13.6832"
        height="13.6326"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_19334_708"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_19334_708"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_n_19334_708"
        x="-0.000366211"
        y="0"
        width="11.8378"
        height="11.8379"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feTurbulence
          type="fractalNoise"
          baseFrequency="0.25 0.25"
          stitchTiles="stitch"
          numOctaves="3"
          result="noise"
          seed="7375"
        />
        <feColorMatrix in="noise" type="luminanceToAlpha" result="alphaNoise" />
        <feComponentTransfer in="alphaNoise" result="coloredNoise1">
          <feFuncA
            type="discrete"
            tableValues="1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
          />
        </feComponentTransfer>
        <feComposite
          operator="in"
          in2="shape"
          in="coloredNoise1"
          result="noise1Clipped"
        />
        <feFlood flood-color="rgba(0, 0, 0, 0.25)" result="color1Flood" />
        <feComposite
          operator="in"
          in2="noise1Clipped"
          in="color1Flood"
          result="color1"
        />
        <feMerge result="effect1_noise_19334_708">
          <feMergeNode in="shape" />
          <feMergeNode in="color1" />
        </feMerge>
      </filter>
      <filter
        id="filter4_n_19334_708"
        x="0.843628"
        y="0.845459"
        width="10.1467"
        height="10.1467"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feTurbulence
          type="fractalNoise"
          baseFrequency="0.25 0.25"
          stitchTiles="stitch"
          numOctaves="3"
          result="noise"
          seed="7963"
        />
        <feColorMatrix in="noise" type="luminanceToAlpha" result="alphaNoise" />
        <feComponentTransfer in="alphaNoise" result="coloredNoise1">
          <feFuncA
            type="discrete"
            tableValues="1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
          />
        </feComponentTransfer>
        <feComposite
          operator="in"
          in2="shape"
          in="coloredNoise1"
          result="noise1Clipped"
        />
        <feFlood flood-color="rgba(0, 0, 0, 0.25)" result="color1Flood" />
        <feComposite
          operator="in"
          in2="noise1Clipped"
          in="color1Flood"
          result="color1"
        />
        <feMerge result="effect1_noise_19334_708">
          <feMergeNode in="shape" />
          <feMergeNode in="color1" />
        </feMerge>
      </filter>
      <filter
        id="filter5_d_19334_708"
        x="0.372986"
        y="3.82568"
        width="11.582"
        height="12.8491"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_19334_708"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_19334_708"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);